import { render, staticRenderFns } from "./SlSvgIcon.vue?vue&type=template&id=28c02a9e&scoped=true&"
import script from "./SlSvgIcon.vue?vue&type=script&lang=js&"
export * from "./SlSvgIcon.vue?vue&type=script&lang=js&"
import style0 from "./SlSvgIcon.vue?vue&type=style&index=0&id=28c02a9e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c02a9e",
  null
  
)

export default component.exports